import { render, staticRenderFns } from "./OnboardingConfirmation.vue?vue&type=template&id=2860df2f&"
import script from "./OnboardingConfirmation.vue?vue&type=script&lang=js&"
export * from "./OnboardingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports